import React, { useState } from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import Login from "./components/login/Login";
import { IS_TEST_MODE } from "./awsConfig";

import "./awsConfig";
import "./index.css";
import Footer from "./components/footer/Footer";
import AppAdmin from "./components/v2/components/AppAdmin";

function App() {
  const [authenticated, setAuthenticated] = useState(IS_TEST_MODE);

  return authenticated ? (
    <>
      <AppAdmin />
    </>
  ) : (
    <>
      <Login onLoginSuccess={() => setAuthenticated(true)} />
      <Footer />
    </>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
